"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "bonusDashboardCtrl",
    function (
      $scope,
      $filter,
      apiSettings,
      BonusRequest,
      model,
      list
    ) {
      var vm = this;
      vm.model = model;
      var $translate = $filter("translate");

      // Pagination
      vm.pagination = {
        list: list,
        currentPage: 1,
        pageSize: apiSettings.defaultPageSize,
        pagesTotal: list.total,
      };

      angular.extend($scope.$parent.vm, {
        title: "Bonificações e Patrocínios",
        insertUrl: "main.bonuses",
      });

      $scope.$watch("vm.pagination.currentPage", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          vm.refresh(newValue);
        }
      });

      vm.refresh = function (page) {
        if (vm.customer == null) {
          var customer = null;
        } else {
          var customer = vm.customer.cnpjCpf;
        }

        var params = {
          userName: vm.userName,
          cpfCnpj: customer,
          statusId: vm.statusId,
          bonusesAndSponsorshipsRequestSubAreaId: vm.subAreaId,
          userId: vm.solicitantId,
        };
        params.page = page;
        BonusRequest.dashboardPage(params).$promise.then(function (data) {
          vm.pagination.list = data;
          vm.pagination.currentPage = data.page;
          vm.pagination.pagesTotal = data.total;
        });
      };

      vm.search = function () {
        vm.refresh(1);
      };

    }
  );
